import React from 'react';

import { MinusCircleOutlined, PlusCircleOutlined, RightOutlined } from "@ant-design/icons";
import { Collapse } from "antd";
import { useDispatch } from "react-redux";
import Checklist from "../../../../components/Checklist";
import LoadingBox from "../../../../components/LoadingBox";
import { openPopup2, POPUP_TYPE } from '../../../../contexts/PopupContext';
import { VesselSideService } from "../../../../util/services/vessel-side";
import { selectOpDetail, selectPermissions } from "../../../../util/store/selectors";
import { useSelector } from "../../../../util/store/store";
import { IChecklist } from "../../../../util/varibles/interface";
import { notify, NotifyCode } from "../../../../util/varibles/message";
import { ACTION } from '../../../../util/varibles/permission';
import { opDetailActions } from "../../reducer";
import stylesContainer from '../../style.module.scss';
import styles from '../style.module.scss';

const ChecklistsDetail: React.FC<{ selectedId?: string }> = (props) => {
    const data = useSelector(selectOpDetail.data);
    const { checklists_v2 = [] } = data;
    const dispatch = useDispatch();
    const [canUpdateOperation] = useSelector(selectPermissions([ACTION.OPERATION.UPDATE]));

    const handleSubmit = (checklist: IChecklist) => {
        const { id, tenant_id } = data.operation;
        return VesselSideService.updateChecklist({
            operation_id: id,
            tenant_id,
            checklists_v2: checklists_v2.map(item => item.id === checklist.id ? checklist : item)
        })
            .then(rs => {
                dispatch(opDetailActions.updateOp([{
                    ...data,
                    checklists_v2: rs
                }]));
                notify.success(NotifyCode.S2)([checklist.name])
            })
    }
    const isEdit = canUpdateOperation;
    console.log('checklists_v2', checklists_v2);
    return <Collapse
        className={styles.collapse}
        bordered={false}
        expandIconPlacement='end'
        defaultActiveKey={props.selectedId}
        expandIcon={props => props.isActive ?
            <MinusCircleOutlined style={{ fontSize: '18px' }} /> :
            <PlusCircleOutlined style={{ fontSize: '18px' }} />
        }
        items={checklists_v2.map(item => {
            const { name = '' } = item || {};

            return {
                key: item.id,
                label: name,
                className: 'mb-2',
                children: <Checklist {...{
                    checklist: item,
                    vesselTenantId: data.vessel?.tenant_id,
                    disabled: !isEdit,
                    onSubmit: isEdit ? (value) => handleSubmit(value) : undefined
                }} />
            }
        })}
    />
}

interface ChecklistsProps {
    isNewChecklistView?: boolean;
}

const Checklists: React.FC<ChecklistsProps> = ({ isNewChecklistView = true }) => {
    const data = useSelector(selectOpDetail.data);
    const { checklists_v2 = [] } = data;

    const handleOpen = (item: IChecklist) => {
        openPopup2(<ChecklistsDetail selectedId={item.id} />, {
            modalProps: { title: `Checklists #${data.operation.operation_code}`, width: '100%' },
            popupType: POPUP_TYPE.DRAWER
        })
    }

    return <div className={[stylesContainer.section, 'h-full min-h-[160px]'].join(' ')}>
        <div className={`${stylesContainer['header-box']}${isNewChecklistView ? ' text-[15px] font-[600]' : ' '}`}>Checklist</div>
        <div className={[
            styles.checklists,
            !isNewChecklistView ? styles['checklists-legacy'] : ''
        ].filter(Boolean).join(' ')}>
            {checklists_v2.length > 0
                ? checklists_v2.map((item, index) => isNewChecklistView
                    ? <div key={item.id} className={styles['checklist-item']}>
                        <button
                            type='button'
                            className={styles.checklist}
                            onClick={() => handleOpen(item)}
                            title={item.name}
                        >
                            <span className={styles['checklist-name']}>{item.name}</span>
                            <span className={styles['checklist-action']} aria-hidden='true'>
                                <RightOutlined />
                            </span>
                        </button>
                        {index < checklists_v2.length - 1 && <div className={styles['checklist-divider']} />}
                    </div>
                    : <div
                        key={item.id}
                        className={styles['checklist-legacy']}
                        onClick={() => handleOpen(item)}
                    >
                        <div>{item.name}</div>
                    </div>)
                : <div className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 mt-4'>
                    <LoadingBox className='mt-[-15px]' message='The checklist is currently empty' />
                </div>}
        </div>
    </div>;
};

export default Checklists;
